define('views/modules/setting/business/payment/billing-informations-form',[
    // Libs
    "underscore",
    "backbone",
    "mustache",
    "moment",
    "bootbox",
    "utils",
    "services/i18n",
    // views
    "views/parts/info-section",
    "views/parts/form/textbox",
    "views/parts/form/select",
    // templates
    "text!templates/modules/setting/business/payment/billing-informations-form.html",
    // collections
    "collections/commons/country",
    "collections/commons/province",
    "collections/commons/us-states",
], function (
    // Libs
    _,
    Backbone,
    Mustache,
    moment,
    Bootbox,
    U,
    i18n,
    // views
    VInfoSection,
    VTextBox,
    VSelect,
    // templates
    TBillingInformationsForm,
    // collections
    CCountries,
    CProvinces,
    CUSStates
) {
    var VPaymentInformationsForm = Backbone.Epoxy.View.extend({
        template: TBillingInformationsForm,

        regions: {
            formElement: ".card-form",
            form: {
                firstName: ".cardholder-firstname-input",
                middleName: ".cardholder-middlename-input",
                lastName: ".cardholder-lastname-input",
                addressLine1: ".cardholder-address1-input",
                addressLine2: ".cardholder-address2-input",
                phoneNumber: ".cardholder-phone-input",

                city: ".cardholder-city-input",
                postalCode: ".cardholder-postal-input",
                country: ".cardholder-country-input",
                regionText: ".cardholder-region-text-input",
                regionState: ".cardholder-region-us-state-input",
                regionProvince: ".cardholder-region-ca-province-input",
            },
        },

        initialize: function (opt) {
            var self = this;
            this.options = opt = opt || {};

            this.view = {
                info: new VInfoSection({
                    title: "payment:your_billing_address_information",
                    content: this.template,
                }),
                form: {
                    firstName: new VTextBox({
                        model: this.options.model,
                        attribute: "firstName",
                        label: "payment:card_owner_firstname",
                        labelposition: "top",
                        validation: true,
                        validationMsg: i18n.t("payment:error_card_name_blank"),
                    }),

                    middleName: new VTextBox({
                        model: this.options.model,
                        attribute: "middleName",
                        label: "payment:card_owner_middlename",
                        labelposition: "top",
                        validation: false,
                    }),

                    lastName: new VTextBox({
                        model: this.options.model,
                        attribute: "lastName",
                        label: "payment:card_owner_lastname",
                        labelposition: "top",
                        validation: false,
                    }),

                    addressLine1: new VTextBox({
                        model: this.options.model,
                        attribute: "addressLine1",
                        label: "payment:card_address_line_1",
                        labelposition: "top",
                        validation: true,
                        validationMsg: i18n.t(
                            "payment:error_card_address_line1_blank"
                        ),
                    }),

                    addressLine2: new VTextBox({
                        model: this.options.model,
                        attribute: "addressLine2",
                        label: "payment:card_address_line_2",
                        labelposition: "top",
                        validation: false,
                    }),

                    city: new VTextBox({
                        model: this.options.model,
                        attribute: "city",
                        label: "payment:card_city",
                        labelposition: "top",
                        validation: true,
                        validationMsg: i18n.t("payment:error_card_city_blank"),
                    }),

                    phoneNumber: new VTextBox({
                        model: this.options.model,
                        attribute: "phoneNumber",
                        label: "payment:card_phone_number",
                        labelposition: "top",
                        validation: true,
                        validationMsg: i18n.t("payment:error_card_phone_blank"),
                    }),

                    country: new VSelect({
                        model: this.options.model,
                        attribute: "country",
                        label: "payment:card_country",
                        labelposition: "top",
                        validation: true,
                        collection: new CCountries(),
                        validationMsg: i18n.t(
                            "payment:error_card_country_unselected"
                        ),
                    }),

                    regionText: new VTextBox({
                        model: this.options.model,
                        attribute: "region",
                        label: "payment:card_region",
                        labelposition: "top",
                        validation: true,
                        validationMsg: i18n.t(
                            "payment:error_card_region_blank"
                        ),
                    }),

                    regionProvince: new VSelect({
                        model: this.options.model,
                        attribute: "region",
                        label: "payment:card_province",
                        labelposition: "top",
                        validation: true,
                        collection: new CProvinces(),
                        validationMsg: i18n.t(
                            "payment:error_card_province_unselected"
                        ),
                    }),

                    regionState: new VSelect({
                        model: this.options.model,
                        attribute: "region",
                        label: "payment:card_state",
                        labelposition: "top",
                        validation: true,
                        collection: new CUSStates(),
                        validationMsg: i18n.t(
                            "payment:error_card_state_unselected"
                        ),
                    }),

                    postalCode: new VTextBox({
                        model: this.options.model,
                        attribute: "postalCode",
                        label: "payment:card_postal_code",
                        labelposition: "top",
                        validation: true,
                        validationMsg: function () {
                            return i18n.t(
                                self.model.get("country") === "US"
                                    ? "payment:error_card_zip_code_blank"
                                    : "payment:error_card_postal_code_blank"
                            );
                        },
                    }),
                },
            };

            this.listenTo(this.model, "change:country", this.onCountryChange);
        },

        render: function () {
            Mustache.render(this.template, Mustache.getContext());

            this.assign(this.view.info, this.$el) // must be first
                .generateZones();

            var view = this.view,
                zone = this.zone;

            Object.keys(view.form).forEach((v) =>
                this.assign(view.form[v], zone.form["$" + v])
            );

            this.onCountryChange();

            return this;
        },

        resetFieldsState: function () {
            Object.values(this.view.form).forEach((field) =>
                field.clearError()
            );
        },

        toggleDisplay: function (isCreditCardPayment) {
            this.$el.toggleClass("hidden", !isCreditCardPayment);
        },

        onCountryChange: function () {
            switch (this.model.get("country")) {
                case "CA":
                    this.view.form.postalCode.setLabel(
                        i18n.t("payment:card_postal_code")
                    );
                    this.zone.form.$regionText.hide();
                    this.zone.form.$regionState.hide();
                    this.zone.form.$regionProvince.show();
                    break;

                case "US":
                    this.view.form.postalCode.setLabel(
                        i18n.t("payment:card_zip_code")
                    );
                    this.zone.form.$regionText.hide();
                    this.zone.form.$regionProvince.hide();
                    this.zone.form.$regionState.show();
                    break;

                default:
                    this.view.form.postalCode.setLabel(
                        i18n.t("payment:card_postal_code")
                    );
                    this.zone.form.$regionProvince.hide();
                    this.zone.form.$regionState.hide();
                    this.zone.form.$regionText.show();
                    break;
            }
        },
    });

    return VPaymentInformationsForm;
});

